import groupBy from 'lodash/groupBy';
import dropRight from 'lodash/dropRight';
import { action, observable, makeObservable } from 'mobx';

import BaseStore from './BaseStore';
import BookingsAPI from '../api/bookings';
import { COUNT_OF_COLUMNS } from '../constants';
import { BookingScreens } from '../components/BookingForm/BookingStates';

const { SLOTS, LOADING, BOOKING_ERROR } = BookingScreens;

class BookingStore extends BaseStore {
  isBusy = false;
  isSending = false;
  bookingSessions = {};
  dateCaches = [];
  activeScreen = SLOTS;
  errorText;

  constructor() {
    super();

    makeObservable(this, {
      isBusy: observable,
      isSending: observable,
      bookingSessions: observable,
      dateCaches: observable,
      activeScreen: observable,
      errorText: observable,
      setDefaultActiveScreen: action,
      getBookingSessions: action,
      makeBooking: action,
      setBookingSessions: action,
      dropLastDateFromCache: action,
    });
  }

  setDefaultActiveScreen = () => {
    this.activeScreen = SLOTS;
  };

  getBookingSessions = async (examCenterName, siteId, dateMin, dateMax, customColumnCount, timezone) => {
    this.isBusy = true;
    this.activeScreen = LOADING;
    try {
      const { data } = await BookingsAPI.list(examCenterName, siteId, dateMin, dateMax, timezone);
      this.setBookingSessions(data, customColumnCount);
      this.activeScreen = SLOTS;
    } catch (error) {
      // eslint-disable-next-line no-console
      this.activeScreen = BOOKING_ERROR;
      console.log(error);
    } finally {
      this.isBusy = false;
    }
  };

  makeBooking = async (payload) => {
    this.isSending = true;
    this.activeScreen = LOADING;
    try {
      const { data } = await BookingsAPI.book(payload);
      if (data) {
        document.location.href = data.payment_url;
      }
    } catch (errors) {
      if (errors?.response?.data?.errorMessages?.message) {
        this.errorText = errors.response.data.errorMessages.message;
      } else {
        this.errorText = '';
      }
      this.activeScreen = BOOKING_ERROR;
    } finally {
      this.isSending = false;
    }
  };

  setBookingSessions = (data, customColumnCount) => {
    let currentDate;
    let previousDate;
    let count = 0;

    const groupedArray = groupBy(data, (slot) => {
      [currentDate] = slot.start_date.split('T');

      if (previousDate !== currentDate) {
        previousDate = currentDate;
        count += 1;
      }

      if (count > (customColumnCount || COUNT_OF_COLUMNS)) {
        return 'other';
      }

      return currentDate;
    });

    delete groupedArray.other;

    this.dateCaches.push(Object.keys(groupedArray));

    this.bookingSessions = groupedArray;
  };

  dropLastDateFromCache = (countOfElements) => {
    this.dateCaches = dropRight(this.dateCaches, countOfElements);
  };
}

export default new BookingStore();
